import { Features } from "./types"

// TODO: add client type when we have it in API2
export function clientHasFeature(client: any, feature: Features.Feature): boolean {
	const featureInList = client.fields?.features?.de?.find(f => f.id === feature.id)
	return Boolean(featureInList && featureInList.status === Features.FeatureStatus.ENABLED)
}